import {inject, observer} from 'mobx-react';
import React, {Component} from 'react';
import classNames from 'classnames';
import {ReactComponent as AddIcon} from '../../assets/images/Share-iOS.svg';
import Paper from '@material-ui/core/Paper';
import {FormattedMessage} from 'react-intl';
import {computed, observable, action} from 'mobx';
import {getUser, getUserStatus, isAdmin, isSchoolUser, isStudent, isTeacher, isUserFirstTime} from '../../utils/userUtility';
import {actions, category, events, UserStatus} from '../../constants/enums';
import BaseConfirmationDialog from '../dialog/BaseConfirmationDialog';
import {customEvent} from '../../utils/analyticsUtil';
import {isDesktop, isIos} from '../../utils/screenUtility';
import './EncouragePWADialog.scss';

const localStoragePWAKey = 'musico-add-to-home-screen';

@inject('userStore')
@observer
class EncouragePWADialog extends Component {
    @observable isChoiceInLocalStorage = localStorage.getItem(localStoragePWAKey)
    standAloneMode = window.matchMedia('(display-mode: standalone)').matches
    firstShowModal = false;

    @action changeChoiceInLocalStorage = value => this.isChoiceInLocalStorage = value;


    @computed get showDialog() {
        const notFirstTime = !this.props.userStore?.user?.firstTime && typeof this.props.userStore?.user?.firstTime !== 'undefined';
        const installToHomeScreenEvent = isIos() ? true : !!this.props.event;
        const show = (installToHomeScreenEvent && !this.isChoiceInLocalStorage && notFirstTime && !this.standAloneMode && !isDesktop());
        if (show && this.firstShowModal) {
            customEvent(events.CustomEvent, {category: category.AddToHomeScreenSuggested});
            this.firstShowModal = true
        }
        return show;
    }

    installToHomeScreen = async () => {
        if (!isIos()) {
            this.props.event.prompt();
            const choiceResult = await this.props.event.userChoice;
            if (choiceResult === 'accepted') {
                localStorage.setItem(localStoragePWAKey, 'accepted')
            } else {
                return this.rejectAddingToHomeScreen();
            }
        }
        customEvent(events.CustomEvent, {category: category.AddedToHomeScreen, label: isIos() ? 'ios' : 'android'});
        this.changeChoiceInLocalStorage(true);
    }

    rejectAddingToHomeScreen = () => {
        customEvent(events.CustomEvent, {category: category.AddToHomeScreenDismissed, label: isIos() ? 'ios' : 'android'});
        localStorage.setItem(localStoragePWAKey, 'rejected')
        this.changeChoiceInLocalStorage(true);
    }

    render() {
        let pwaButtonText = 'notification.homeScreen.btnText';
        let pwaMessageText = 'notification.homeScreen.text';
        if (isIos()) {
            pwaButtonText = 'notification.homeScreen.btnText.ios';
            pwaMessageText = 'notification.homeScreen.text.ios';
        }
        return <BaseConfirmationDialog
            withClose={true}
            onSubmit={this.installToHomeScreen}
            onDismiss={this.rejectAddingToHomeScreen}
            open={this.showDialog}
            className={'encourage-pwa-dialog'}
            buttonText={pwaButtonText}
            withConfirm={!isStudent()}
            text={{
                question: 'notification.homeScreen.header',
                message: pwaMessageText,
                itemName: <AddIcon className='encourage-pwa-icon'/>
            }}
            isCancel={false}
        />;
    }
}

export default EncouragePWADialog;
